export default {"src":"/_next/static/media/mhc-logo-mobile.a2b04709.svg","height":37,"width":385,"blurWidth":0,"blurHeight":0};